import { render, staticRenderFns } from "./patternButton.vue?vue&type=template&id=54c992d0&"
import script from "./patternButton.vue?vue&type=script&lang=ts&"
export * from "./patternButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports